import { z } from 'zod';
export const webApiErrorSchema = z.object({
    error: z
        .object({
        message: z.string().optional(),
        code: z.string().optional(),
        errorCode: z.string().optional(),
        issues: z.unknown().optional(),
    })
        .passthrough(),
});
export const booleanSuccessResponseSchema = z.object({
    success: z.boolean(),
});
export const webApiBooleanSchema = z.union([
    z.boolean(),
    z.literal(1).transform(() => true),
    z.literal(0).transform(() => false),
    z.literal('true').transform(() => true),
    z.literal('false').transform(() => false),
]);
export function parseWebApiResponse(schema, data, endpoint) {
    const result = schema.safeParse(data);
    if (result.success) {
        return result.data;
    }
    const error = new Error(`${endpoint} response did not match its Web API contract`);
    error.issues = result.error.issues;
    throw error;
}
